<div role="button" tabindex="0"
  class="flex flex-col min-h-40 cursor-pointer items-start border border-solid border-[#B4BFCB] rounded-xl"
  [class]="direction" [attr.aria-label]="routeCardAriaLabel" (click)="onCardActivate($event)"
  (mouseenter)="onCardMouseEnter()" (keydown.enter)="onCardKeyActivate($event)"
  (keydown.space)="onCardKeyActivate($event)">
  <div class="flex flex-col gap-2 pt-4 pb-2 flex-1 w-full">
    <div class="flex justify-between items-center">
      @if (!!route.travelSummary) {
      <div class="flex gap-2 px-4 items-baseline items-center">
        <div class="flex items-center">
          <span class="text-[#3D5979] text-sm">
            {{ route.travelSummary.travelTime.start | localizedDate:'EE' }}, {{ route.travelSummary.travelTime.start |
            localizedDate:'dd.MM' }}
          </span>
        </div>
        <div class="flex gap-2 items-center">
          <span class="!text-base">
            {{ route.travelSummary.travelTime.startHour | hour }}
          </span>
          <!-- Decorative arrow between start/end times; full info is in the surrounding spans and routeCardAriaLabel. -->
          <ng-icon class="font-black text-xs text-[#3D5979]" [name]="sectionIconName" aria-hidden="true"></ng-icon>
          <span class="!text-base">
            {{ route.travelSummary.travelTime.endHour | hour }}
          </span>
        </div>
        <small class="route-duration text-[#3D5979] text-sm">
          {{ timeText }}
        </small>
        <!--   <div class="flex items-center gap-2 justify-end" style="flex-grow: 1">
        <ng-icon [name]="getImageFromCrowdedness(route.routeCrowdedness)" class="colored-icon" />
        <div class="flex items-center gap-2"></div>
        Crowdedness icon removed from here
      </div>-->
      </div>
      }
      <div class="px-4">
        <img [src]="crowdednessIconSrc" [alt]="resolveCrowdednessAlt()" class="colored-icon crowdedness-icon" />
      </div>
    </div>

    @if (!!route.sections) {
    <div class="items-center flex flex-wrap px-4 gap-3">
      @for (section of route.sections; track section; let i = $index) {
      <ng-container class="flex items-center gap-[0.375rem]">
        <app-source-destination-results-list-item-section [section]="section" />
        @if (i < route.sections.length - 1) { <!-- Decorative arrow between consecutive trip sections; mode info is on
          each section icon. -->
          <ng-icon class="font-black text-xs text-[#3D5979]" [name]="sectionIconName" aria-hidden="true" />
          }
      </ng-container>
      }
    </div>
    }
    @if (firstTransitSection?.departure?.nextStopsTimes?.length) {
    <app-source-destination-results-list-item-stop-times [departureData]="firstTransitSection?.departure"
      [isFutureSearch]="route.isFutureSearch" />
    }
    @if (hasSpecialData) {
    <app-result-list-item-special-data [specialData]="route.specialData" [specialMessages]="route.specialMessages"
      [agencyId]="computedAgencyId"
      [crowdednessIconName]="route.routeCrowdedness ? getImageFromCrowdedness(route.routeCrowdedness) : null" />
    }

    @if (!!showRoutePrice && !!selectedProfile) {
    <app-tariff-profile-price [selectedProfile]="selectedProfile" [prices]="route.travelSummary.price" />
    }
  </div>
</div>